module.exports = __webpack_public_path__ + "static/media/bluefrenchsteth.9acc967c.png";